module.exports = __webpack_public_path__ + "static/media/icon-page.bbc58cac.svg";